import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NSGridModule } from '@norfolk-southern/accessns-components';

import { EBillFinanceComponent } from '@ruby/modules/ebill/submodules/ebill-finance/components/ebill-finance.component';
import { EBillFinanceContainer } from '@ruby/modules/ebill/submodules/ebill-finance/containers/ebill-finance.container';
import { EBillFinanceRoutingModules } from '@ruby/modules/ebill/submodules/ebill-finance/ebill-finance-routing.modules';

@NgModule({
  declarations: [
    EBillFinanceContainer,
    EBillFinanceComponent
  ],
  imports: [
    CommonModule,
    NSGridModule,
    MatButtonModule,
    EBillFinanceRoutingModules,
    MatIconModule,
    MatProgressBarModule
  ],
  exports: [EBillFinanceContainer]
})
export class EBillFinanceModules {}
